module.exports = __webpack_public_path__ + "static/media/1006.826b1763.png";